
export const HOST = process.env.REACT_APP_SERVER_URL;
